import 'twin.macro'

import FFLogo from 'assets/icons/FreedomLogo'
import PhoneIcon from 'assets/icons/PhoneIcon'
import UserIcon from 'assets/icons/UserIcon'
import WhatsappIcon from 'assets/icons/WhatsApp'
import ContactItem from 'components/UI/contact/contacat-item'
import LangToggle from 'components/UI/lang-toggle'
import { MenuToggle } from 'components/UI/menu-toggle/menu-toggle'
import { motion } from 'framer-motion'
import i18n from 'i18next'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { useLocation, useLockBodyScroll } from 'react-use'
import tw from 'twin.macro'
import { useWindowSize } from 'usehooks-ts'

import AuthModal from './auth-modal'
import ThemeToggle from './theme-toggle'
import { pathnames } from 'utils/steps'
import { isAuthSelector } from 'redux/store/slices/auth-slice'
import { setOpenModalAfterBuy } from 'redux/store/slices/application-slice'

const langs = [
  {
    value: 'rus',
    title: 'Рус'
  },
  {
    value: 'eng',
    title: 'Eng'
  }
]

function MobileHeader() {
  const [scroll, setScroll] = useState(0)
  const { t } = useTranslation()
  const { height } = useWindowSize()
  const isAuthenticated = useSelector(isAuthSelector)
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null)
  const [queryParams] = useSearchParams()

  const sidebar = {
    open: (height = 1000) => ({
      clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
      transition: {
        type: 'spring',
        stiffness: 20,
        restDelta: 2
      }
    }),
    closed: {
      clipPath: 'circle(1px at 1px 1px)',
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 40
      }
    }
  }
  const [isOpen, toggleOpen] = useState(false)

  const location = useLocation().pathname

  useLockBodyScroll(isOpen)
  window.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY
    setScroll(scrollPosition)
  })

  const isActivationFlow = useMemo(
    () =>
      location === pathnames['activation-enter-phone'] ||
      location === pathnames['activation-loading'] ||
      location === pathnames['otp-verify'] ||
      location === pathnames['idn-enter'] ||
      location === pathnames['error'],
    [location]
  )

  const handleLogout = () => {
    window.open(pathnames.main, '_self')
    dispatch(setOpenModalAfterBuy(false))
  }

  useEffect(() => {
    if (queryParams !== null) {
      if (queryParams.has('phoneNumber')) {
        setPhoneNumber(queryParams.get('phoneNumber')?.trim() || '')
      }
      if (queryParams.has('isCartomat') && queryParams.get('isCartomat') === 'true') {
        setIsModalOpen(true)
      }
      if (queryParams.has('lang')) {
        document.cookie = `django_language=${queryParams.get('lang')}; max-age=300; path=/;`
        sessionStorage.setItem('django_language', queryParams.get('lang') || 'kk')
        i18n.changeLanguage(queryParams.get('lang') || 'kk')
      }
    }
  }, [phoneNumber, queryParams])

  return (
    <div
      tw='bg-header w-full z-20 transition-colors h-[68px] flex items-center'
      css={[scroll > 100 && tw`bg-secondary shadow-md`]}
    >
      <div tw='w-full flex items-center justify-between'>
        <a href='https://bankffin.kz/ru'>
          <FFLogo />
        </a>
        <div tw='flex items-center gap-2'>
          <LangToggle />
          <ThemeToggle />
          {
            <motion.div initial={false} animate={isOpen ? 'open' : 'closed'} custom={height}>
              <motion.div
                tw='absolute bottom-0 right-0 h-full flex flex-col pt-5 w-full bg-primary overflow-hidden z-20 h-[93vh] pb-24 top-[68px]'
                variants={sidebar}
              >
                <div tw='flex flex-col w-full px-5 h-full justify-between'>
                  <button
                    tw='bg-secondary h-[70px] items-center flex font-semibold gap-2 px-4 rounded-s20 w-full border'
                    onClick={() => {
                      isAuthenticated ? handleLogout() : setIsModalOpen(true)
                    }}
                  >
                    <div tw='w-[32px] h-[32px] bg-[#D1D1D6] rounded-full flex items-center justify-center text-primary-inverted'>
                      <UserIcon />
                    </div>
                    <p>{isAuthenticated ? t('nav.sign_out', { ns: 'cabinet' }) : t('sign_in', { ns: 'header' })}</p>
                  </button>
                  <div tw='text-[#5C5C5C] flex flex-col items-center gap-5'>
                    {/*<ContactItem link='https://wa.me/77760595595' icon={<WhatsappIcon />} label='+7 776 1 595 595' />*/}
                    <ContactItem link='tel:595' icon={<PhoneIcon />} label='595' />
                  </div>
                </div>
              </motion.div>
              {!isActivationFlow && <MenuToggle toggle={() => toggleOpen(!isOpen)} isOpen={isOpen} />}
              <AuthModal
                cartomatPhoneNumber={phoneNumber || ''}
                channel='auth'
                open={isModalOpen}
                onClose={() => {
                  setIsModalOpen(false)
                  toggleOpen(false)
                }}
              />
            </motion.div>
          }
        </div>
      </div>
    </div>
  )
}

export default MobileHeader
